import { render, staticRenderFns } from "./MyprofilePreview.vue?vue&type=template&id=bc5bed36&scoped=true"
import script from "./MyprofilePreview.vue?vue&type=script&lang=js"
export * from "./MyprofilePreview.vue?vue&type=script&lang=js"
import style0 from "./MyprofilePreview.vue?vue&type=style&index=0&id=bc5bed36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5bed36",
  null
  
)

export default component.exports